import { createSlice, createSelector } from "@reduxjs/toolkit";
import { getAllChairsByMap } from "../../store/Chairs/ChairsThunk";
import { keysEqual } from "../../../../utils/equalityFunctions";

const initialState = {
  chairs: [],
  loading: false,
  error: null,
};

const chairsSlice = createSlice({
  name: "chairs",
  initialState,
  reducers: {
    setChairs: (state, action) => {
      if (!Array.isArray(action.payload)) {
        console.error("Payload is not an array:", action.payload);
        return;
      }
      state.chairs = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllChairsByMap.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllChairsByMap.fulfilled, (state, action) => {
        const chairs = action.payload?.data || action.payload;
        state.chairs = Array.isArray(chairs) ? chairs : [];
        state.loading = false;
        state.error = null;
      })
      .addCase(getAllChairsByMap.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch chairs by map";
        console.error("Failed to fetch chairs by map:", action.error);
      });
  },
});

export const {
  setChairs,
} = chairsSlice.actions;

export const selectChairsObject = createSelector(
    [(state) => state.chairs.chairs],
    (chairs) => {
        const result = {};
        for (const chair of chairs) {
            result[chair.id] = chair;
        }
        return result;
    },
    {
      // Change when needed
        memoizeOptions: {
            equalityCheck: keysEqual
        }
    }
);


export default chairsSlice.reducer;